module.exports = __webpack_public_path__ + "static/media/33-12.73a0e83d.mp3";